module.exports = __webpack_public_path__ + "static/banner-mobile-1f6eff826921327fc4af1b06da99b0cc.png";